import * as React from 'react';
import { st, classes } from './CoreButton.st.css';
/**
 * Button
 */
export const CoreButton = (props) => {
    const { disabled } = props;
    return (React.createElement("button", { ...props, className: st(classes.root, { disabled }, props.className) }));
};
CoreButton.displayName = 'CoreButton';
//# sourceMappingURL=CoreButton.js.map